<div class="explanations-tools">
    <p class="explanations-tools__text">
        Book your hotel room at <a href="https://www.booking.com/index.html?aid=7947415" target="_blank" (click)="goToBookingAffiliateHandler()"><img src="https://res.cloudinary.com/djxk74uhg/image/fetch/f_auto/https://cdn.routeperfect.com/app/images/images/booking.png?_a=ATFGlAA0" alt="booking"/></a> through us and enjoy free travel perks
    </p>

    <ul class="explanations-tools__permissions">
        @for (permission of permissions; track $index) {
            <li class="explanations-tools__permission">
                <div class="explanations-tools__item">
                    <p class="explanations-tools__permission--title">
                        <span>{{ permission.title | translate }}</span>
                        <span class="explanations-tools__worth">{{ permission.profit | translate }}</span>
                    </p>
                    <p class="explanations-tools__permission--text">{{ permission.description | translate }}</p>
                </div>
            </li>
        }
    </ul>
</div>
